// ** React Imports
import { lazy } from 'react';

const InsuranceCompanies = [
  {
    path: 'insurance-companies',
    component: lazy(() => import('pages/insurance-companies')),
  },
];

export default InsuranceCompanies;
